import { Component, h, Ref } from "@lukekaalim/act";
import { Mini, MiniModel, MiniModelID } from "../../../defs";
import { TheatreSceneResources } from "../../../hooks";
import { ObjectClone } from "@kosmod/graphics-3d";
import { useLogger } from "@kosmod/kit";
import { Object3D } from "three";

export type MiniModelGraphicRendererProps = {
  miniModelId: MiniModelID,

  mini: Mini,
  res: TheatreSceneResources,
  ref?: Ref<Object3D | null>,
}

export const MiniModelGraphicRenderer: Component<MiniModelGraphicRendererProps> = ({
  miniModelId,
  mini,
  res,
  ref,
}) => {
  const model = res.miniModels.get(miniModelId);

  // const logger = useLogger(`MiniModelGraphicRenderer(${mini.id}, ${miniModelId})`)

  // logger.log(`Model`, model)

  return [
    !!model && h(ObjectClone, { target: model, ref, position: {
      x: mini.position.vector.x + .5,
      y: 0 + .5,
      z: mini.position.vector.y
    } })
  ];
};
